<section class="related" *ngIf="properties?.length">
    <h2 class="related-title">Descubre más Propiedades</h2>

    <p-carousel
        [value]="properties"
        [numVisible]="3"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
    >
        <ng-template let-item pTemplate="item">
            <div class="related-item">
                <app-property-card [vm]="item" (select)="select.emit($event)"></app-property-card>
            </div>
        </ng-template>
    </p-carousel>
</section>
